var path = 'app/checkout/help/help.tpl.html';
var html = "<div class=panel> <div class=panel-body ng-bind-html=$ctrl.helpHTML></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;